const Queries = {
    investment: {
      link: "https://www.investopedia.com/terms/i/investment.asp"
    },
    budgeting: {
      link: "https://www.nerdwallet.com/article/finance/how-to-budget"
    },
    loans: {
      link: "https://www.investopedia.com/terms/l/loan.asp" // add the link for loans
    },
    savings: {
        link: "/login"
    }

  };

export default Queries;